"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

require("./LocalFitterSec.scss");

var _aos = _interopRequireDefault(require("aos"));

require("aos/dist/aos.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var LocalFitterSec = function LocalFitterSec(props) {
  var _props$data = props.data,
      initialText = _props$data.initialText,
      secondText = _props$data.secondText,
      subParagraph = _props$data.subParagraph,
      mainImg = _props$data.mainImg,
      buttonText = _props$data.buttonText;
  (0, _react.useEffect)(function () {
    _aos.default.init({
      duration: 1000
    });
  }, []);
  return _react.default.createElement("section", {
    className: "fitter-wrapper"
  }, _react.default.createElement("img", {
    className: "tyreManImg",
    src: mainImg.url,
    alt: "tyre fitter"
  }), _react.default.createElement("div", {
    className: "sub-fitter-wrapper"
  }, _react.default.createElement("h2", {
    "data-aos": "fade-up",
    "data-aos-easing": "ease-out-back",
    "data-aos-duration": "1000"
  }, initialText, _react.default.createElement("br", null), " ", secondText), _react.default.createElement("div", {
    className: "localFitterP",
    "data-aos": "fade-up",
    "data-aos-easing": "ease-out-back",
    "data-aos-duration": "1000"
  }, (0, _htmlReactParser.default)(subParagraph)), _react.default.createElement("button", {
    className: "btn"
  }, _react.default.createElement("a", {
    href: "#"
  }, buttonText))));
};

LocalFitterSec.defaultProps = {
  initialText: "",
  secondText: "",
  subParagraph: "",
  buttonText: ""
};
var _default = LocalFitterSec;
exports.default = _default;